import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-PepiconsCircle",
  "use": "icon-PepiconsCircle-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"icon-PepiconsCircle\"><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.5 10a5.5 5.5 0 1 0 11 0a5.5 5.5 0 0 0-11 0Zm9 0a3.5 3.5 0 1 1-7 0a3.5 3.5 0 0 1 7 0Z\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol